import styled from "styled-components";
import Rectangle from "../../../images/Rectangle.svg";
import Company from "../../../images/Company.svg";

export const MainDiv = styled.div`
  display: flex;
  width: 100%;
  height: 100vh; /* Ensure the container takes the full height of the viewport */

  .left_container {
    width: 50%;
    background-size: cover;
    background-position: center;
    display: flex;
    justify-content: center;
    align-items: center;

    div {
      width: 400px;
      height: 211px;
      display: flex;
      flex-direction: column;

      .head1 {
        width: 400px;
        height: 40px;
        font-size: 20px;
        font-weight: 700;
        line-height: 25.82px;
        color: #1e2228;
      }
      .head2 {
        height: 11px;
        font-size: 16px;
        font-weight: 700;
        line-height: 20.66px;
        color: #1e2228;
      }
      & button{
      display:flex;
      justify-content:flex-end;
    //   width: fit-content;
      }
    }
  }

  .right_container {
    width: 50%;
    background-image: url(${Rectangle});
    background-size: cover;
    background-position: center;

    display: flex;
    justify-content: center;
    align-items: center;

    div {
      background-image: url(${Company});
      background-size: contain;
      background-repeat: no-repeat;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 488.1px;
      height: 269px;
    }
  }
`;
export const BoldText = styled.p`
    color: #1e2228;
    font-family: Basis Grotesque Pro;
    font-size: ${(props) => (props.fontSize ? props.fontSize : "20px")};
    text-transform: ${(props) => (props.textTransform ? props.textTransform : "none")};
    font-style: normal;
    font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 700)};
    line-height: normal;
    margin-right: ${(props) => (props.marginRight ? props.marginRight : "20px")};
    margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};

    margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : "")};
`;

export const Tooltip = styled.div`
    visibility: hidden;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 8px;
    padding: 8px 12px;
    position: absolute;
    z-index: 1;
    bottom: 125%; /* Position above the button */
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    transition: opacity 0.3s;
    white-space: nowrap;
    font-size: 12px;
    display: flex;
    justify-content: center;
    &:after {
        content: '';
        height: 12px;
        width: 12px;
        background-color: black;
        position: absolute;
        transform: rotate(45deg);
        bottom: -6px;

    }
`;
export const EditWrapper = styled.div`
    border-radius: 6px;
    background: #edf0fd;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: ${(props) => (props.marginLeft ? props.marginLeft : "")};
    cursor: pointer !important;
    &:hover {
        background: #1b49ea;
    }
    margin-right: ${props=>props.right?props.right:"10px"};
    /* &:last-child {
        margin-right: 0px;
    } */
`;